export const DEMO_CREDENTIALS = {
  manager: {
    label: 'Manager Access',
    email: 'demo.manager@erp-mock.com',
    password: 'DemoManager123!',
  },
  salesRep: {
    label: 'Sales Rep Access',
    email: 'demo.rep1@erp-mock.com',
    password: 'DemoRep123!',
  },
} as const;

export interface DemoRoleCredentials {
  label: string;
  username: string;
  email: string;
  password: string;
}

export interface PersonalizedDemoCredentials {
  manager: DemoRoleCredentials;
  salesRep: DemoRoleCredentials;
}

export function buildPersonalizedDemoCredentials(
  managerUsername: string,
  salesRepUsername?: string
): PersonalizedDemoCredentials {
  return {
    manager: {
      label: DEMO_CREDENTIALS.manager.label,
      username: managerUsername,
      email: DEMO_CREDENTIALS.manager.email,
      password: DEMO_CREDENTIALS.manager.password,
    },
    salesRep: {
      label: DEMO_CREDENTIALS.salesRep.label,
      username: salesRepUsername || `${managerUsername}.rep`,
      email: DEMO_CREDENTIALS.salesRep.email,
      password: DEMO_CREDENTIALS.salesRep.password,
    },
  };
}
